//@ts-ignore
import Dialog from './Dialog.vue';

export default Dialog;
